import React from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {Card} from '@vio/atlas/src/components/designSystem/Card'

import {ROOM_CARD_GALLERY_HEIGHT_MOBILE} from '../constants'
import {RoomsFiltersTitle} from '../RoomsFilters'
import {
  RoomBasicsSkeletonMobile,
  RoomCardSkeletonDesktop,
  RoomCardSkeletonDesktopXs,
  RoomOfferSkeletonVerticalMobile
} from './SkeletonPartials'

const RoomsListSkeletonDesktop = () => (
  <Box display="flex" flexDirection="column" gap="s500">
    <RoomCardSkeletonDesktop />
    <RoomCardSkeletonDesktop />
    <RoomCardSkeletonDesktop />
  </Box>
)

const RoomsListSkeletonDesktopXs = () => (
  <Box display="flex" flexDirection="column" gap="s500">
    <RoomCardSkeletonDesktopXs />
    <RoomCardSkeletonDesktopXs />
    <RoomCardSkeletonDesktopXs />
  </Box>
)

const RoomsCardSkeletonMobile = () => {
  return (
    <Card borderColorPath="border.neutral.secondary" borderRadius="lg">
      <Box height={`${ROOM_CARD_GALLERY_HEIGHT_MOBILE}px`}>
        <SkeletonLoader height="100%" />
      </Box>
      <Box padding="s400" paddingTop="s600" paddingBottom="s200">
        <RoomBasicsSkeletonMobile />
      </Box>
      <RoomsListSkeletonMobileVertical />
    </Card>
  )
}

const RoomsListSkeletonMobileVertical = () => (
  <Box
    paddingTop="s600"
    paddingLeft="s400"
    paddingRight="s400"
    paddingBottom="s400"
    gap="s300"
    display="flex"
    flexDirection="column"
  >
    <Card borderColorPath="border.neutral.secondary" borderRadius="lg">
      <RoomOfferSkeletonVerticalMobile />
    </Card>
    <Card borderColorPath="border.neutral.secondary" borderRadius="lg">
      <RoomOfferSkeletonVerticalMobile />
    </Card>
  </Box>
)

export const FiltersSkeleton = () => {
  const {isMobile} = useDeviceLayout()

  return (
    <Box display="flex" gap={isMobile ? 's300' : 's500'} alignItems="center">
      <RoomsFiltersTitle />
      <Box display="flex" gap="s300" alignItems="center">
        <SkeletonLoader width={136} marginTop={0} />
        <SkeletonLoader width={136} marginTop={0} />
        <SkeletonLoader width={136} marginTop={0} />
      </Box>
    </Box>
  )
}

export const RoomsListSkeleton = () => {
  const {isMobile, isDesktopXs} = useDeviceLayout()

  if (isMobile) {
    return <RoomsCardSkeletonMobile />
  }

  if (isDesktopXs) {
    return <RoomsListSkeletonDesktopXs />
  }

  return <RoomsListSkeletonDesktop />
}
